import clientFactory from '../clientFactory';

import httpLink from '../links/httpLink';

const refreshTokenClient = clientFactory([
  httpLink,
]);

export default refreshTokenClient;
